<template>
  <v-card-text>
    <v-flex v-if="has_loading_text" xs12 :class="['text-center', light? 'white--text' : 'primary--text']">{{loadingText}}...</v-flex>
    <!-- <v-progress-linear indeterminate color="white" class="mb-0" ></v-progress-linear> -->
    <v-flex xs12 class="mt-2 text-center">
      <v-progress-circular :size="size_progress_circular" :width="width_progress_circular" :color="loadingColor" indeterminate></v-progress-circular>
    </v-flex>
  </v-card-text>
</template>

<script>
export default {
  name: "cardLoading",
  props: {
    size_progress_circular: {
      type: Number,
      default: () => 70
    },
    width_progress_circular: {
      type: Number,
      default: () => 7
    },
    loadingText: {
      type: String,
      default: () => "Carregando"
    },
    loadingColor: {
      type: String,
      default: () => "primary"
    },
    light:{
      type: Boolean,
      default: () => false
    },
    has_loading_text:{
      type: Boolean,
      default: () => true
    },
  }
};
</script>

<style scoped>
</style>